import React, {
  FC, ReactElement, useEffect, useMemo, useState,
} from 'react';
import {
  Button, Flex, Input, Row,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { Filters } from '../lib/types';

interface TableHeaderProps {
  children: ReactElement
  activeFilters: Filters
  onClearFilters: () => void
  tableHeaderButtons?: ReactElement[]
  onFullTableSearch?: (value: string) => void
  className?: string
  enableClearFilters?: boolean
}

export const TableHeader:FC<TableHeaderProps> = React.memo((props: TableHeaderProps) => {
  const {
    className, children, tableHeaderButtons, onFullTableSearch, activeFilters, enableClearFilters, onClearFilters,
  } = props;

  const [globalFilterValue, setGlobalFilterValue] = useState<string>('');

  useEffect(() => {
    if (onFullTableSearch) {
      onFullTableSearch(globalFilterValue);
    }
  }, [globalFilterValue]);

  const clearFilters = () => {
    onClearFilters();
    setGlobalFilterValue('');
  };

  const isClearButtonDisabled: boolean = useMemo(() => _.isEmpty(Object.values(activeFilters).filter((item) => !!item))
    && _.isEmpty(globalFilterValue), [activeFilters, globalFilterValue]);

  return (
    <Row className={className}>
      {(!!tableHeaderButtons?.length || onFullTableSearch) && (
        <Flex style={{ width: '100%', padding: '16px 8px' }} justify={tableHeaderButtons ? 'flex-end' : 'flex-start'}>
          {onFullTableSearch && (
            <div style={{ width: 264 }}>
              <Input
                size="large"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setGlobalFilterValue(event.target.value)}
                suffix={<SearchOutlined />}
                value={globalFilterValue}
                allowClear
              />
            </div>
          )}
          <Flex style={{ flexGrow: 1 }} gap={8} justify="flex-end">
            {enableClearFilters && (
              <Button
                type="default"
                disabled={isClearButtonDisabled}
                onClick={() => clearFilters()}
              >
                Сбросить фильтры
              </Button>
            )}
            {tableHeaderButtons}
          </Flex>
        </Flex>
      )}
      <div style={{ width: '100%' }}>
        {children}
      </div>
    </Row>
  );
});
